import { alpha, Box } from '@mui/material';
import CenteredProgress from 'components/progress/centered-progress/centered-progress.component';

type BackdropCenteredProgressType = {
  isLoading: boolean;
};

const BackdropCenteredProgress = ({
  isLoading,
}: BackdropCenteredProgressType) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={theme => ({
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1000,
        backgroundColor: alpha(theme.palette.background.paper, 0.5),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
      data-testid="BackdropCenteredProgress"
    >
      <CenteredProgress />
    </Box>
  );
};

export default BackdropCenteredProgress;
